module.exports = {"baseBg":"#fefefe","baseText":"#222","buttonBg":"#d14210","buttonText":"#fefefe","linkColor":"#0974bc","borderColor":"#848b95","goodResult":"#a1c454","badResult":"#c45454"}


//////////////////
// WEBPACK FOOTER
// ./colors.json
// module id = ./colors.json
// module chunks = 1